import { render, staticRenderFns } from "./presenter-component.vue?vue&type=template&id=6f742b5f&scoped=true&"
import script from "./presenter-component.vue?vue&type=script&lang=ts&"
export * from "./presenter-component.vue?vue&type=script&lang=ts&"
import style0 from "./presenter-component.vue?vue&type=style&index=0&id=6f742b5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f742b5f",
  null
  
)

export default component.exports